import styled from 'styled-components';

import { Text18 } from '../../ui/Text18';
import { Text32 } from '../../ui/Text32';

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.lightGray};
  border-radius: 8px;
  padding: 32px;
  margin-top: 48px;
  max-width: 1400px;
  min-width: 320px;
  display: flex;
  justify-content: space-between;

  @media (max-width: 1035px) {
    flex-direction: column;
  }
`;

export const Column = styled.div``;

export const ColumnSum = styled.div`
  @media (max-width: 1035px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 48px;
  }
`;

export const ColumnSumItem = styled.div``;

export const InsuraceCompanyLogo = styled.img`
  height: 71px;
`;

export const InsuranceInfo = styled.div`
  margin-top: 35px;
`;

export const InfoItem = styled(Text18)`
  margin-bottom: 8px;
`;

export const InfoItemAlert = styled(InfoItem)`
  color: ${({ theme }) => theme.colors.darkGray};
`;

export const InfoItemBold = styled.span`
  font-weight: 700;
  margin-left: 10px;
`;

export const AmountTitle = styled(InfoItem)`
  font-weight: 700;
`;

export const AmountSum = styled(Text32)<{ color?: string }>`
  ${({ color, theme }) =>
    color === 'blue' && 'color:' + theme.colors.accentBlue};
  font-weight: 700;
`;

export const AmountTitleTotal = styled(AmountTitle)`
  margin-top: 32px;
  @media (max-width: 1035px) {
    margin-top: 0px;
  }
`;

